<template>
    <div class="an-page">
        <div class="an-head">
            <span class="an-title-ic"><v-icon small>mdi-chart-box-outline</v-icon></span>
            <h1 class="an-title">{{ $t('Analytics') }}</h1>
        </div>

        <div class="an-grid">
            <router-link v-for="sector in sectors" :key="sector.to" :to="sector.to" class="an-card" :aria-label="$t(sector.label)">
                <span class="an-card-art" aria-hidden="true">
                    <img src="../assets/images/momah.png" alt="" class="an-card-emblem" />
                </span>
                <span class="an-card-body">
                    <span class="an-card-ic"><v-icon small>{{ sector.icon }}</v-icon></span>
                    <span class="an-card-title">{{ $t(sector.label) }}</span>
                </span>
                <span class="an-card-cta">
                    <span>{{ $t('ReadMore') }}</span>
                    <v-icon small class="an-card-arrow">mdi-arrow-left</v-icon>
                </span>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                sectors: [
                    { label: 'Eskan', icon: 'mdi-home-city-outline', to: '/executive-analytics' },
                    { label: 'Balady', icon: 'mdi-city-variant-outline', to: '/balady-analytics' }
                ]
            }
        }
    }
</script>

<style scoped>
    .an-page {
        --an-surface: #f3f6f5;
        --an-line: #e6ecea;
        --an-text: #1f2a28;
        --an-muted: #6b7a77;
        --an-primary: #0a716e;
        --an-primary-tint: #e6f2f1;
        --an-ease: cubic-bezier(.2, .8, .2, 1);
        padding: 22px 20px 40px;
        background: #fff;
        min-height: 60vh;
    }

    .an-head { display: flex; align-items: center; gap: 12px; margin-bottom: 20px; }
    .an-title-ic {
        display: inline-flex; align-items: center; justify-content: center;
        width: 42px; height: 42px; border-radius: 13px; background: var(--an-primary-tint);
    }
    .an-title-ic .v-icon { color: var(--an-primary) !important; }
    .an-title { margin: 0; font-size: 22px; font-weight: 800; line-height: 1.2; color: var(--an-text); }

    .an-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 460px));
        gap: 20px;
        justify-content: center;
        max-width: 1000px;
        margin: 0 auto;
    }

    .an-card {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 18px;
        padding: 22px 22px 20px;
        border: 1px solid var(--an-line);
        border-radius: 22px;
        background: #fff;
        text-decoration: none;
        color: var(--an-text);
        overflow: hidden;
        box-shadow: 0 1px 2px rgba(15, 23, 42, .04), 0 8px 24px -16px rgba(15, 23, 42, .18);
        transition: transform .25s var(--an-ease), box-shadow .25s var(--an-ease), border-color .25s var(--an-ease);
    }
    .an-card:hover, .an-card:focus-visible {
        transform: translateY(-4px);
        border-color: var(--an-primary);
        box-shadow: 0 1px 2px rgba(15, 23, 42, .04), 0 22px 40px -20px rgba(10, 113, 110, .45);
        outline: none;
    }

    .an-card-art {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 190px;
        border-radius: 16px;
        background: radial-gradient(circle at 50% 40%, #eef7f0 0%, var(--an-surface) 70%);
    }
    .an-card-emblem {
        height: 150px;
        width: auto;
        mix-blend-mode: multiply;
        transition: transform .3s var(--an-ease);
    }
    .an-card:hover .an-card-emblem { transform: scale(1.05); }

    .an-card-body { display: flex; align-items: center; gap: 12px; }
    .an-card-ic {
        display: inline-flex; align-items: center; justify-content: center;
        flex: 0 0 40px; width: 40px; height: 40px; border-radius: 12px; background: var(--an-primary-tint);
    }
    .an-card-ic .v-icon { color: var(--an-primary) !important; }
    .an-card-title { font-size: 20px; font-weight: 800; color: var(--an-text); }

    .an-card-cta {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        align-self: flex-start;
        height: 40px;
        padding: 0 18px;
        border-radius: 12px;
        background: var(--an-primary);
        color: #fff;
        font-size: 13.5px;
        font-weight: 700;
        box-shadow: 0 8px 18px -10px var(--an-primary);
        transition: background-color .2s var(--an-ease);
    }
    .an-card-cta .v-icon { color: #fff !important; transition: transform .25s var(--an-ease); }
    .an-card:hover .an-card-cta { background: #085c5a; }
    .an-card:hover .an-card-arrow { transform: translateX(-4px); }
    [dir="ltr"] .an-card-arrow, .v-application:not(.v-application--is-rtl) .an-card-arrow { transform: rotate(180deg); }
    [dir="ltr"] .an-card:hover .an-card-arrow, .v-application:not(.v-application--is-rtl) .an-card:hover .an-card-arrow { transform: rotate(180deg) translateX(-4px); }

    @media (max-width: 600px) {
        .an-page { padding: 14px 12px 28px; }
        .an-title { font-size: 19px; }
        .an-card-art { height: 150px; }
        .an-card-emblem { height: 118px; }
    }
    @media (prefers-reduced-motion: reduce) {
        .an-card, .an-card-emblem, .an-card-cta, .an-card-cta .v-icon { transition: none; }
        .an-card:hover { transform: none; }
    }
</style>
